import React,{forwardRef} from 'react'
import errorIcon from '../images/icon-error.svg'
import Style from './Input.module.css'

const Input = (probs,ref) => {
  return (
    <div className={Style.Input}>
        <label htmlFor={probs.id} hidden={true}>
          {probs.placeholder}
        </label>
        <input 
        type={probs.type}
        className={probs.className}
        placeholder={probs.placeholder}
        id={probs.id}
        ref={ref}
        data-error={probs.error}
        />
        <img
        src={errorIcon}
        className={`errorIcon`}
        data-error={probs.error}
        alt=""
        
        />
        <p
        data-error={probs.error}
        >
          {probs.ErrorMessage}
        </p>
    </div>
  )
}

export default forwardRef(Input)